export default {
  user_profile: {
    name: ''
  },
  tmp_task: JSON.parse(localStorage.getItem('tmp_task') || '{}'),
  tmp_topic: JSON.parse(localStorage.getItem('tmp_topic') || '{}')
}
